// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2caTF","name":"Header_name__25hiH","birthday":"Header_birthday__3wQoU","skeleton":"Header_skeleton__27kyh"};